<template lang="pug">
.info-card
  .info-card-header
    .info-card-icon(:class='`info-card-icon--${iconColor}`' v-if='icon')
      icon(:name='icon')
    .info-card-title {{ title }}
    .info-card-action
      slot(name='action')
  .info-card-body
    slot
</template>

<script>
import Icon from '@/ui/atoms/Icon.vue';

export default {
  name: 'InfoCard',
  components: {
    Icon,
  },
  props: {
    icon: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      required: true,
    },
    iconColor: {
      type: String,
      default: 'green',
    },
  },
};
</script>

<style scoped lang="stylus">
.info-card
  background-color: #fff
  border: 1px solid rgba(204, 204, 204, .5)
  border-radius: 8px
  padding: 1.25rem
  margin-bottom: 1.25rem
.info-card-header
  display: flex
  align-items: center
  gap: 0.75rem
  margin-bottom: 1rem
.info-card-icon
  display: flex
  align-items: center
  justify-content: center
  flex: 0 0 auto
  width: 2rem
  height: 2rem
  border-radius: 50%
  font-size: 0.9rem

  &--green
    background-color: #E7F0EF
    color: #19665B

  &--blue
    background-color: #EAF1FB
    color: #2C6FBB
.info-card-title
  font-weight: 600
  font-size: 0.95rem
  flex: 1 1 auto
.info-card-action
  flex: 0 0 auto
</style>
